// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseTable-container {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  overflow-anchor: none;
}
.BaseTable-container tbody > a {
  color: inherit;
  text-decoration: none;
}
.BaseTable-container tr {
  display: grid;
  grid-template-columns: 26px minmax(0, 2fr);
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  width: 100%;
  padding: 12px 12px 12px 8px;
  border-radius: 4px;
}
.BaseTable-container th,
.BaseTable-container td {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.BaseTable-container .BaseTable-title {
  justify-content: flex-start;
  height: 20px;
}
.BaseTable-container .BaseTable-TableRow {
  width: 100%;
}

.BaseTable-hasSort {
  margin-right: -5.5px;
}

.BaseTable-tableHead {
  background-color: var(--color_neutral_100);
}
.BaseTable-tableHead th {
  color: var(--color_neutral_800);
  font-size: 12px;
}

.BaseTable-hasClick {
  cursor: pointer;
}

.BaseTable-tableBody td {
  color: var(--color_neutral_800);
  font-size: 14px;
}
.BaseTable-tableBody:hover {
  background-color: var(--color_primary_100);
}
.BaseTable-tableBody .BaseTable-colorDot {
  width: 16px;
  height: 16px;
  border-radius: 99px;
}
.BaseTable-tableBody .BaseTable-numberSection {
  color: var(--color_neutral_500);
  font-size: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BaseTable-tableHead > .BaseTable-activeItem {
  color: var(--color_primary_500);
}

.BaseTable-sortButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 0px;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/base-table/base-table.styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;AACF;AACE;EACE,cAAA;EACA,qBAAA;AACJ;AAEE;EACE,aAAA;EACA,0CAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;AAAJ;AAGE;;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ;AAIE;EACE,2BAAA;EACA,YAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;;AAOA;EACE,oBAAA;AAJF;;AAOA;EACE,0CAAA;AAJF;AAME;EACE,+BAAA;EACA,eAAA;AAJJ;;AAQA;EACE,eAAA;AALF;;AASE;EACE,+BAAA;EACA,eAAA;AANJ;AASE;EACE,0CAAA;AAPJ;AAUE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AARJ;AAWE;EACE,+BAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATJ;;AAaA;EACE,+BAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAVF","sourcesContent":[".BaseTable-container {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  overflow-anchor: none;\n\n  tbody > a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  tr {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 2fr);\n    grid-auto-flow: column;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    padding: 12px 12px 12px 8px;\n    border-radius: 4px;\n  }\n\n  th,\n  td {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  .BaseTable-title {\n    justify-content: flex-start;\n    height: 20px;\n  }\n\n  .BaseTable-TableRow {\n    width: 100%;\n  }\n}\n\n.BaseTable-hasSort {\n  margin-right: -5.5px;\n}\n\n.BaseTable-tableHead {\n  background-color: var(--color_neutral_100);\n\n  th {\n    color: var(--color_neutral_800);\n    font-size: 12px;\n  }\n}\n\n.BaseTable-hasClick {\n  cursor: pointer;\n}\n\n.BaseTable-tableBody {\n  td {\n    color: var(--color_neutral_800);\n    font-size: 14px;\n  }\n\n  &:hover {\n    background-color: var(--color_primary_100);\n  }\n\n  .BaseTable-colorDot {\n    width: 16px;\n    height: 16px;\n    border-radius: 99px;\n  }\n\n  .BaseTable-numberSection {\n    color: var(--color_neutral_500);\n    font-size: 14px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.BaseTable-tableHead > .BaseTable-activeItem {\n  color: var(--color_primary_500);\n}\n\n.BaseTable-sortButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  padding: 0px;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
